<template>
    <div class="hiw-content flex xl:flex-row lg:flex-row flex-row md:flex-col justify-between items-start">
        <HowItWorkLeft />
        <HowItWorkRight :img="hiwimg" :rpimg="hiwimg2" />
    </div>
</template>

<script>
    import HowItWorkLeft from "./HowItWorkLeft";
    import HowItWorkRight from "./HowItWorkRight";
    export default {
        name: "HowItWork",
        components: {
            HowItWorkRight,
            HowItWorkLeft
        },
        data() {
            return {
                hiwimg: require('@/assets/images/hiw-mobile.jpg'),
                hiwimg2: require('@/assets/images/mobile.png'),
            }
        }
    }
</script>

<style scoped>

</style>